import { gql } from "@apollo/client";

export const GET_API_CONNECTIONS = gql`
  query GetApiConnections {
    apiConnections(pagination: { start: 0, limit: -1 }) {
      data {
        id
        attributes {
          name
          application_id
          weightron_uid
          collection_id
          weightron_secret
          weightron_key
          endpoint_url
          active
          updatedAt
        }
      }
    }
  }
`;

export const CREATE_API_CONNECTION = gql`
  mutation CreateApiConnection($input: ApiConnectionInput!) {
    createApiConnection(data: $input) {
      data {
        id
        attributes {
          name
          application_id
          weightron_uid
          collection_id
          weightron_secret
          weightron_key
          endpoint_url
          updatedAt
        }
      }
    }
  }
`;

export const UPDATE_API_CONNECTION = gql`
  mutation UpdateApiConnection($id: ID!, $input: ApiConnectionInput!) {
    updateApiConnection(id: $id, data: $input) {
      data {
        id
        attributes {
          name
          application_id
          weightron_uid
          collection_id
          weightron_secret
          weightron_key
          endpoint_url
          updatedAt
        }
      }
    }
  }
`;

export const DELETE_API_CONNECTION = gql`
  mutation DeleteApiConnection($id: ID!) {
    deleteApiConnection(id: $id) {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

export const TEST_CONNECTION = gql`
  mutation APITestConnection($data: ApiConnectionInput!) {
    testConnection(api: $data) {
      status
      message
    }
  }
`;
